import { Injectable } from "@angular/core";
import { IFindSenderByMail } from "../model/contact-or-person.model";
import { ICustomData } from "../model/customData.model";
import { IAppointmentExtension } from "../model/appointmentExtension.model";
import { PersonDefaultAvatarUrl } from "../utilities/ImageUrl";

@Injectable({
    providedIn: "root",
})
export class AppointmentSharedService {
    public formData: ICustomData;
    public knownContacts: IFindSenderByMail[];
    public extensionData: ICustomData;
    public attendee: Office.EmailAddressDetails;
    public pendingAttendees: { type: "required" | "optional"; attendees: Office.EmailAddressDetails[] } | null = null;

    private currentAppointmentId: string | null = null;

    public resetIfNewAppointment(appointmentId: string | null): void {
        if (!appointmentId || appointmentId === this.currentAppointmentId) {
            return;
        }
        this.currentAppointmentId = appointmentId;
        this.formData = undefined;
        this.knownContacts = null;
        this.extensionData = undefined;
        this.attendee = null;
        this.pendingAttendees = null;
    }

    // Real ids, not 0 — this appointment is linked, only the names failed to load; zeroing the
    // ids would let an untouched Save overwrite the link. Names are "" not null: convertPersonItem
    // (contact-provider.ts) concatenates FullName into the combobox text, and null renders as "null".
    public applyExtensionWithoutDetails(extension: IAppointmentExtension, preserveFormData: boolean): void {
        this.extensionData = {
            ContactId: extension.contactId ?? 0,
            ContactName: "",
            PersonId: extension.personId ?? 0,
            PersonFullName: "",
            PersonEmailAddress: "",
            Image: PersonDefaultAvatarUrl,
            ProjectId: extension.projectId ?? 0,
            ProjectName: "",
            SaleId: extension.saleId ?? 0,
            SaleTitle: "",
            AppointmentTypeId: extension.appointmentTypeId ?? 0,
            AppointmentTypeName: "",
        };
        if (!preserveFormData) {
            this.formData = Object.assign({}, this.extensionData);
        }
    }
}
